import { render, staticRenderFns } from "./UserOffline.vue?vue&type=template&id=66abc394&scoped=true&"
import script from "./UserOffline.vue?vue&type=script&lang=js&"
export * from "./UserOffline.vue?vue&type=script&lang=js&"
import style0 from "./UserOffline.vue?vue&type=style&index=0&id=66abc394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66abc394",
  null
  
)

export default component.exports